$.fn.ProjectList = function() {
  let self = this

  self.marginTop = function() {
    var margin_top = ($(window).height() / 2) - (self.height() / 2)
    self.css('margin-top', margin_top + 'px')
  }
  self.marginTop();

  self.scroll = function() {
    var projects = self.closest('.row').find('.grid__item > div')
    projects.each(function() {
      var offset = $(this).offset().top - $(window).scrollTop() + 30
      if (offset > 0) {
        if (!self.find('.item-' + $(this).attr('data-id')).hasClass('--selected')) {
          self.find('.project-list__item').removeClass('--selected')
          self.find('.item-' + $(this).attr('data-id')).addClass('--selected');
        }
        return false;
      }

      if ($('.project-list__item.--selected').length < 1) {
        $('.project-list__item.--selected').first().addClass('--selected');
      }
    })
  }

  return function() {
    $(window).on('resize orientationchange load', self.marginTop)
    $(window).scroll(self.scroll)
    return self
  }()
}
